import { defineMessages } from 'react-intl';

const messages = defineMessages({
  twitter: {
    id: 'Twitter',
    defaultMessage: 'Twitter',
  },
  twitterUsername: {
    id: 'Twitter username',
    defaultMessage: 'Twitter username',
  },
});

export const twitterSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.twitter),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['twitter_username'],
      },
    ],

    properties: {
      twitter_username: {
        title: props.intl.formatMessage(messages.twitterUsername),
        type: 'string',
        default: '',
        noValueOption: false,
      },
    },
    required: ['twitter_username'],
  };
};
